export const formatNumber = (number: number): string => {
	return new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0 }).format(
		number
	);
};
